import React, { useState, useEffect } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { lockerService, accountService, alertService } from '../../_services'; 
import { Table } from "react-bootstrap";
import moment from 'moment';

function Reassign() {
    let { id } = useParams();
    const history = useHistory();
    const [submittingReassign, setSubmittingReassign] = useState(false);
    const [originLocker, setOriginLocker] = useState({
        id: '',
        lockerType: '',
        lockerTypeId: '',
        venue: '',
        guiAdmin: '',
        isEnabled: '',
        reservationId: '',
        area: ''
    });
    const [availLockers, setAvailLockers] = useState(null);
    const [selectedLocker, setSelectedLocker] = useState(null);

    async function fetchData() {
        try {
            const locker = await lockerService.getById(id);
            setOriginLocker(locker);
            const availLockers = await accountService.getLockersForReassign(locker.id);
            console.log("Available lockers: ", availLockers);
            setAvailLockers(availLockers);
        } catch (error) {
            console.log("ERROR FETCHING DATA: ", error);
        }
    }

    useEffect(() => {
        fetchData();
    }, [id]);

    function reassignRental() {
        let confirmed = window.confirm('Move Rental from ' + originLocker.guiAdmin + ' to ' + selectedLocker.guiAdmin);
        if (confirmed) {
            setSubmittingReassign(true);
                lockerService.reassignRental(originLocker.guiAdmin, selectedLocker.guiAdmin, originLocker.venue)
                    .then(() => {
                        setSubmittingReassign(false);
                        alertService.success('Rental Reassigned!', { keepAfterRouteChange: true });
                        
                        history.push("/lockers-admin/kiosks/" + originLocker.venue);
                    })
                .catch(error => { setSubmittingReassign(false); alertService.error(error) });
        }
    }

    function selectLocker(e) {
        var locker = availLockers.find(l => l.id == e.target.value);
        setSelectedLocker(locker);
    }

    return (
        <div className="card m-3">
            <div className="card-header header-admin">
                <h1 className="bold-tx">Reassign Rental</h1>
                <h3 className="bold-tx">From: {originLocker.guiAdmin}</h3>
            </div>
            <Table className="table table-striped" responsive="sm">
                <thead>
                    <tr>
                        <th className="admin-btm-bdrline">Locker#</th>
                        <th className="admin-btm-bdrline">Size</th>
                        <th className="admin-btm-bdrline">Enabled</th>
                        <th className="admin-btm-bdrline">Rented</th>
                        <th className="admin-btm-bdrline">Select</th>
                    </tr>
                </thead>
                <tbody>
                    {availLockers && availLockers
                        .sort((a, b) => a.guiAdmin - b.guiAdmin)
                        .map(locker =>
                        <tr className="admin-top-bdrline" key={locker.id}>
                            <td>{locker.guiAdmin} </td>
                            <td>{locker.lockerType}</td>
                            <td>{locker.isEnabled ? "True" : "False"}</td>
                            <td>{locker.reservationId}</td>
                            <td>
                                <input type="radio" name="selectedLocker" value={locker.id} onChange={(e) => selectLocker(e)} />
                            </td>
                        </tr>
                    )}
                    {!availLockers &&
                        <tr>
                            <td colSpan="4" className="text-center">
                                <span className="spinner-border spinner-border-lg align-center"></span>
                            </td>
                        </tr>
                    }
                </tbody>
            </Table>
            <Link onClick={() => history.goBack()} className="btn btn-link">Back</Link>
            <button className="btn btn-primary" onClick={() => reassignRental()}>Reassign</button>
        </div>
    )
}

export { Reassign }; 